<div class="height-100" #parent>
  <p-virtualScroller *ngIf="parentModalRendered" [value]="participants | async" [itemSize]="96" [style]="{height: height}" styleClass="participation-scroller"
                     [lazy]="true">
    <ng-template let-participant pTemplate="item">
      <div class="flex justify-content-start align-items-center w-full pl-2" style="gap: 10px; height: 96px;">
        <ng-container *ngIf="!isPlaceholder(participant); else participantSkeleton">
          <app-thumbnail
            [imgSrc]="participant.data.avatar | mediaObject"
            [circle]="true"
            size="lg"
          >
          </app-thumbnail>
          <div class="flex flex-column flex-1">
            <a (click)="navigateToProfile(participant)">{{ getParticipantUsername(participant) }}</a>
            <span *ngIf="getParticipantFullName(participant)" class="text-sm text-600">
            {{ getParticipantFullName(participant) }}
          </span>
          </div>
          <ng-container [ngSwitch]="getFollowState(participant)">
            <button
              class="p-button p-button-outlined p-button-icon-only p-button-rounded p-button-sm"
              *ngIf="isFollowButtonVisible(participant)"
              style="margin-left: auto"
            >
              <span *ngSwitchDefault (click)="postFollowing(participant)" class="material-icons">favorite_border</span>
              <app-spinner [inline]="true" size="1em" *ngSwitchCase="'pending'"></app-spinner>
              <span *ngSwitchCase="'filled'" (click)="removeFollowing(participant)" class="material-icons">favorite</span>
            </button>
          </ng-container>
        </ng-container>
        <ng-template #participantSkeleton>
          <p-skeleton shape="circle" size="3rem" styleClass="mr-2"></p-skeleton>
          <div style="flex: 1">
            <p-skeleton width="8rem" height="1rem" borderRadius="16px" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="6rem" height="0.9rem" borderRadius="16px"></p-skeleton>
          </div>
        </ng-template>
      </div>
    </ng-template>
    <ng-template pTemplate="loadingItem">
      <div class="flex">
        <p-skeleton shape="circle" size="4rem" styleClass="mr-2"></p-skeleton>
        <div style="flex: 1">
          <p-skeleton width="100%" height="1.5rem" borderRadius="16px" styleClass="mb-2 mt-1"></p-skeleton>
          <p-skeleton width="75%" height="1.5rem" borderRadius="16px"></p-skeleton>
        </div>
      </div>
    </ng-template>
  </p-virtualScroller>
</div>
